import { render, staticRenderFns } from "./web-preview.vue?vue&type=template&id=45730d8e"
import script from "./web-preview.vue?vue&type=script&lang=js"
export * from "./web-preview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports